// Gifting product
class GiftingProductWrapper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    window.addEventListener("load", () => this.init());
  }
  init() {
    const emblaNode = this.querySelector(".gift-embla");
    if (!emblaNode) {
      console.warn("Embla container not found inside gifting-product-wrapper");
      return;
    }

    const viewportNode = emblaNode.querySelector(".embla-viewport");
    const prevButton = this.querySelector(".embla-prev");
    const nextButton = this.querySelector(".embla-next");

    if (typeof EmblaCarousel !== "undefined" && viewportNode) {
      const embla = EmblaCarousel(viewportNode, {
        loop: true,
        align: "start",
        slidesToScroll: 1,
        draggable: true,
      });

      if (prevButton) {
        prevButton.addEventListener("click", () => embla.scrollPrev());
      }
      if (nextButton) {
        nextButton.addEventListener("click", () => embla.scrollNext());
      }
    }
  }
}
customElements.define("gifting-product-wrapper", GiftingProductWrapper);
// About snack community
class AboutSnackSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    window.addEventListener("load", () => this.init());
  }
  init() {
    const emblaNode = this.querySelector(".snacksEmbla");
    if (!emblaNode) {
      console.warn("Embla container not found inside about-snack-wrapper");
      return;
    }

    const viewportNode = emblaNode.querySelector(".embla-viewport");
    if (typeof EmblaCarousel !== "undefined" && viewportNode) {
      const autoplay = EmblaCarouselAutoplay(
        { delay: 2500, stopOnInteraction: true },
        (emblaRoot) => emblaRoot.parentElement
      );

      const embla = EmblaCarousel(
        viewportNode,
        {
          loop: true,
          align: "center",
          slidesToScroll: 1,
          draggable: true,
        },
        [autoplay]
      );
    }
  }
}
customElements.define("about-snack-wrapper", AboutSnackSlider);
class CraftedSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    window.addEventListener("load", () => this.init());
    window.addEventListener("resize", this.handleResize.bind(this));
  }
  init() {
    const emblaNode = this.querySelector(".crafted-embla");
    if (!emblaNode) {
      console.warn("Embla container not found inside crafted-wrapper");
      return;
    }

    const viewportNode = emblaNode.querySelector(".embla-viewport");
    if (typeof EmblaCarousel !== "undefined" && viewportNode) {
      const autoplay = EmblaCarouselAutoplay(
        { delay: 2500, stopOnInteraction: true },
        (emblaRoot) => emblaRoot.parentElement
      );

      const embla = EmblaCarousel(
        viewportNode,
        {
          loop: true,
          align: "start",
          slidesToScroll: 1,
          draggable: true,
        },
        [autoplay]
      );
    }

    this.handleResize();
  }
  handleResize() {
    let ele = this.querySelector("#craftedContainer");
    if (ele) {
      let height = window.innerWidth - ele.offsetLeft;
      this.querySelector(".handle-embla-wrapper").style.maxWidth = `${
        height - 15
      }px`;
    }
  }
}
customElements.define("crafted-wrapper", CraftedSlider);
// Partner slider
class PartnerEmbla extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    window.addEventListener("load", () => this.init());
  }
  init() {
    const emblaNode = this.querySelector(".partners-embla");
    if (!emblaNode) {
      console.warn("Embla container not found inside partners-wrapper");
      return;
    }

    const viewportNode = emblaNode.querySelector(".embla-viewport");

    if (typeof EmblaCarousel !== "undefined" && viewportNode) {
      const autoplay = EmblaCarouselAutoplay(
        { delay: 2500, stopOnInteraction: true },
        (emblaRoot) => emblaRoot.parentElement
      );

      const embla = EmblaCarousel(
        viewportNode,
        {
          loop: true,
          align: "center",
          slidesToScroll: 1,
          draggable: true,
        },
        [autoplay]
      );
    }
  }
}
customElements.define("partners-wrapper", PartnerEmbla);
// Real Talk
class RealTalkSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    window.addEventListener("load", () => this.init());
  }
  init() {
    const emblaNode = this.querySelector(".real-talk-embla");
    if (!emblaNode) {
      console.warn("Embla container not found inside real-talks-wrapper");
      return;
    }

    const viewportNode = emblaNode.querySelector(".embla-viewport");
    const prevButton = this.querySelector(".embla-prev");
    const nextButton = this.querySelector(".embla-next");

    if (typeof EmblaCarousel !== "undefined" && viewportNode) {
      const embla = EmblaCarousel(viewportNode, {
        loop: true,
        align: "center",
        slidesToScroll: 1,
        draggable: true,
      });

      if (prevButton) {
        prevButton.addEventListener("click", () => embla.scrollPrev());
      }
      if (nextButton) {
        nextButton.addEventListener("click", () => embla.scrollNext());
      }
    }
  }
}
customElements.define("real-talks-wrapper", RealTalkSlider);
// Trusted retailer
class TrustedRetailer extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    window.addEventListener("load", () => this.init());
  }
  init() {
    const emblaNode = this.querySelector(".retailer-embla");
    if (!emblaNode) {
      console.warn("Embla container not found inside trusted-retailer-wrapper");
      return;
    }

    const viewportNode = emblaNode.querySelector(".embla-viewport");
    const prevButton = this.querySelector(".embla-prev");
    const nextButton = this.querySelector(".embla-next");
    const desktopPrevBtn = this.querySelector(".desktop-prev-btn");
    const desktopNextBtn = this.querySelector(".desktop-next-btn");

    if (typeof EmblaCarousel !== "undefined" && viewportNode) {
      const embla = EmblaCarousel(viewportNode, {
        loop: true,
        align: "start",
        slidesToScroll: 1,
        draggable: true,
      });

      const updateButtons = () => {
        if (prevButton) prevButton.disabled = !embla.canScrollPrev();
        if (nextButton) nextButton.disabled = !embla.canScrollNext();
        if (desktopPrevBtn) desktopPrevBtn.disabled = !embla.canScrollPrev();
        if (desktopNextBtn) desktopNextBtn.disabled = !embla.canScrollNext();
      };

      embla.on("select", updateButtons);
      embla.on("init", updateButtons);

      if (prevButton) {
        prevButton.addEventListener("click", () => embla.scrollPrev());
      }
      if (nextButton) {
        nextButton.addEventListener("click", () => embla.scrollNext());
      }
    }
  }
}
customElements.define("trusted-retailer-wrapper", TrustedRetailer);
